// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3EUUN","additionalInfo":"AgreementModal_additionalInfo__33yQr"};